<template>
  <div>
    <a-spin size="large"> </a-spin>
  </div>
</template>

<script>
import { login, isAuth } from "@/services/user";
import { MONITOR_PAGE } from "@/router/index";
export default {
  data() {
    return {};
  },
  mounted() {
    this.autoCall();
    // console.log(this.$route);
    // 检查当前用户权限
    if (this.checkAuth()) {
      this.toMonitor();
    } else {
      this.login() // 登录
        .then(() => {
          // 正常 跳到监控页面
          this.toMonitor();
        })
        .catch(error => {
          // 失败后跳到错误页面
          console.log(error.message);
          this.toLoginFail(error.message);
        });
    }
    // 未登录到 获取用户凭证，访问后端进行授权认证
  },

  methods: {
    autoCall() {
      // 百应自动呼叫
      const call = this.$route.query.call;
      if ("1" === call) {
        this.$store.commit("setAutoCall", true);
      }
    },
    checkAuth() {
      // 检查是否已登录
      return isAuth();
    },
    login() {
      const result = this.getAuthToken();
      // console.log(result);
      if (result) {
        const { token, billingCode, prod } = result;
        // 获取 token, billingCode, prod
        return login(token, billingCode, prod);
        // 获取有URL中的凭证信息， 访问后端进行认证
      } else {
        return Promise.reject(new Error("用户信息验证错误"));
      }
    },
    toMonitor() {
      this.$router.push({ name: MONITOR_PAGE });
    },
    toLoginFail(message) {
      // this.$router.push({ name: ERROR_PAGE });
      // 提示登陆失败
      this.$info({
        title: "提示",
        content: message,
        onOk: () => {
          window.open("", "_self").close();
        }
      });
    },
    getAuthToken() {
      if (window.IS_SHOW_LOG) {
        console.log(location.href);
      }
      const token = this.$route.query.token;
      const billingCode = this.$route.query.billingCode;
      const prod = this.$route.query.prod;

      const checkQuery = query => query && query !== "";
      if (checkQuery(token) && checkQuery(billingCode) && checkQuery(prod)) {
        return { token, billingCode, prod };
      } else {
        return false;
      }
    }
  }
};
</script>

<style></style>
